module.exports = __webpack_public_path__ + "img/card-bg.0ca9768.png";